import _classCallCheck from "/home/runner/work/hakka.finance/hakka.finance/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/home/runner/work/hakka.finance/hakka.finance/node_modules/@babel/runtime/helpers/esm/createClass";
import _assertThisInitialized from "/home/runner/work/hakka.finance/hakka.finance/node_modules/@babel/runtime/helpers/esm/assertThisInitialized";
import _inherits from "/home/runner/work/hakka.finance/hakka.finance/node_modules/@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "/home/runner/work/hakka.finance/hakka.finance/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/home/runner/work/hakka.finance/hakka.finance/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _wrapNativeSuper from "/home/runner/work/hakka.finance/hakka.finance/node_modules/@babel/runtime/helpers/esm/wrapNativeSuper";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

export var JOSEError = /*#__PURE__*/function (_Error) {
  _inherits(JOSEError, _Error);

  var _super = _createSuper(JOSEError);

  function JOSEError(message) {
    var _this;

    _classCallCheck(this, JOSEError);

    var _a;

    _this = _super.call(this, message);
    _this.code = 'ERR_JOSE_GENERIC';
    _this.name = _this.constructor.name;
    (_a = Error.captureStackTrace) === null || _a === void 0 ? void 0 : _a.call(Error, _assertThisInitialized(_this), _this.constructor);
    return _this;
  }

  _createClass(JOSEError, null, [{
    key: "code",
    get: function get() {
      return 'ERR_JOSE_GENERIC';
    }
  }]);

  return JOSEError;
}( /*#__PURE__*/_wrapNativeSuper(Error));
export var JWTClaimValidationFailed = /*#__PURE__*/function (_JOSEError) {
  _inherits(JWTClaimValidationFailed, _JOSEError);

  var _super2 = _createSuper(JWTClaimValidationFailed);

  function JWTClaimValidationFailed(message) {
    var _this2;

    var claim = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'unspecified';
    var reason = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'unspecified';

    _classCallCheck(this, JWTClaimValidationFailed);

    _this2 = _super2.call(this, message);
    _this2.code = 'ERR_JWT_CLAIM_VALIDATION_FAILED';
    _this2.claim = claim;
    _this2.reason = reason;
    return _this2;
  }

  _createClass(JWTClaimValidationFailed, null, [{
    key: "code",
    get: function get() {
      return 'ERR_JWT_CLAIM_VALIDATION_FAILED';
    }
  }]);

  return JWTClaimValidationFailed;
}(JOSEError);
export var JWTExpired = /*#__PURE__*/function (_JOSEError2) {
  _inherits(JWTExpired, _JOSEError2);

  var _super3 = _createSuper(JWTExpired);

  function JWTExpired(message) {
    var _this3;

    var claim = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'unspecified';
    var reason = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'unspecified';

    _classCallCheck(this, JWTExpired);

    _this3 = _super3.call(this, message);
    _this3.code = 'ERR_JWT_EXPIRED';
    _this3.claim = claim;
    _this3.reason = reason;
    return _this3;
  }

  _createClass(JWTExpired, null, [{
    key: "code",
    get: function get() {
      return 'ERR_JWT_EXPIRED';
    }
  }]);

  return JWTExpired;
}(JOSEError);
export var JOSEAlgNotAllowed = /*#__PURE__*/function (_JOSEError3) {
  _inherits(JOSEAlgNotAllowed, _JOSEError3);

  var _super4 = _createSuper(JOSEAlgNotAllowed);

  function JOSEAlgNotAllowed() {
    var _this4;

    _classCallCheck(this, JOSEAlgNotAllowed);

    _this4 = _super4.apply(this, arguments);
    _this4.code = 'ERR_JOSE_ALG_NOT_ALLOWED';
    return _this4;
  }

  _createClass(JOSEAlgNotAllowed, null, [{
    key: "code",
    get: function get() {
      return 'ERR_JOSE_ALG_NOT_ALLOWED';
    }
  }]);

  return JOSEAlgNotAllowed;
}(JOSEError);
export var JOSENotSupported = /*#__PURE__*/function (_JOSEError4) {
  _inherits(JOSENotSupported, _JOSEError4);

  var _super5 = _createSuper(JOSENotSupported);

  function JOSENotSupported() {
    var _this5;

    _classCallCheck(this, JOSENotSupported);

    _this5 = _super5.apply(this, arguments);
    _this5.code = 'ERR_JOSE_NOT_SUPPORTED';
    return _this5;
  }

  _createClass(JOSENotSupported, null, [{
    key: "code",
    get: function get() {
      return 'ERR_JOSE_NOT_SUPPORTED';
    }
  }]);

  return JOSENotSupported;
}(JOSEError);
export var JWEDecryptionFailed = /*#__PURE__*/function (_JOSEError5) {
  _inherits(JWEDecryptionFailed, _JOSEError5);

  var _super6 = _createSuper(JWEDecryptionFailed);

  function JWEDecryptionFailed() {
    var _this6;

    _classCallCheck(this, JWEDecryptionFailed);

    _this6 = _super6.apply(this, arguments);
    _this6.code = 'ERR_JWE_DECRYPTION_FAILED';
    _this6.message = 'decryption operation failed';
    return _this6;
  }

  _createClass(JWEDecryptionFailed, null, [{
    key: "code",
    get: function get() {
      return 'ERR_JWE_DECRYPTION_FAILED';
    }
  }]);

  return JWEDecryptionFailed;
}(JOSEError);
export var JWEInvalid = /*#__PURE__*/function (_JOSEError6) {
  _inherits(JWEInvalid, _JOSEError6);

  var _super7 = _createSuper(JWEInvalid);

  function JWEInvalid() {
    var _this7;

    _classCallCheck(this, JWEInvalid);

    _this7 = _super7.apply(this, arguments);
    _this7.code = 'ERR_JWE_INVALID';
    return _this7;
  }

  _createClass(JWEInvalid, null, [{
    key: "code",
    get: function get() {
      return 'ERR_JWE_INVALID';
    }
  }]);

  return JWEInvalid;
}(JOSEError);
export var JWSInvalid = /*#__PURE__*/function (_JOSEError7) {
  _inherits(JWSInvalid, _JOSEError7);

  var _super8 = _createSuper(JWSInvalid);

  function JWSInvalid() {
    var _this8;

    _classCallCheck(this, JWSInvalid);

    _this8 = _super8.apply(this, arguments);
    _this8.code = 'ERR_JWS_INVALID';
    return _this8;
  }

  _createClass(JWSInvalid, null, [{
    key: "code",
    get: function get() {
      return 'ERR_JWS_INVALID';
    }
  }]);

  return JWSInvalid;
}(JOSEError);
export var JWTInvalid = /*#__PURE__*/function (_JOSEError8) {
  _inherits(JWTInvalid, _JOSEError8);

  var _super9 = _createSuper(JWTInvalid);

  function JWTInvalid() {
    var _this9;

    _classCallCheck(this, JWTInvalid);

    _this9 = _super9.apply(this, arguments);
    _this9.code = 'ERR_JWT_INVALID';
    return _this9;
  }

  _createClass(JWTInvalid, null, [{
    key: "code",
    get: function get() {
      return 'ERR_JWT_INVALID';
    }
  }]);

  return JWTInvalid;
}(JOSEError);
export var JWKInvalid = /*#__PURE__*/function (_JOSEError9) {
  _inherits(JWKInvalid, _JOSEError9);

  var _super10 = _createSuper(JWKInvalid);

  function JWKInvalid() {
    var _this10;

    _classCallCheck(this, JWKInvalid);

    _this10 = _super10.apply(this, arguments);
    _this10.code = 'ERR_JWK_INVALID';
    return _this10;
  }

  _createClass(JWKInvalid, null, [{
    key: "code",
    get: function get() {
      return 'ERR_JWK_INVALID';
    }
  }]);

  return JWKInvalid;
}(JOSEError);
export var JWKSInvalid = /*#__PURE__*/function (_JOSEError10) {
  _inherits(JWKSInvalid, _JOSEError10);

  var _super11 = _createSuper(JWKSInvalid);

  function JWKSInvalid() {
    var _this11;

    _classCallCheck(this, JWKSInvalid);

    _this11 = _super11.apply(this, arguments);
    _this11.code = 'ERR_JWKS_INVALID';
    return _this11;
  }

  _createClass(JWKSInvalid, null, [{
    key: "code",
    get: function get() {
      return 'ERR_JWKS_INVALID';
    }
  }]);

  return JWKSInvalid;
}(JOSEError);
export var JWKSNoMatchingKey = /*#__PURE__*/function (_JOSEError11) {
  _inherits(JWKSNoMatchingKey, _JOSEError11);

  var _super12 = _createSuper(JWKSNoMatchingKey);

  function JWKSNoMatchingKey() {
    var _this12;

    _classCallCheck(this, JWKSNoMatchingKey);

    _this12 = _super12.apply(this, arguments);
    _this12.code = 'ERR_JWKS_NO_MATCHING_KEY';
    _this12.message = 'no applicable key found in the JSON Web Key Set';
    return _this12;
  }

  _createClass(JWKSNoMatchingKey, null, [{
    key: "code",
    get: function get() {
      return 'ERR_JWKS_NO_MATCHING_KEY';
    }
  }]);

  return JWKSNoMatchingKey;
}(JOSEError);
export var JWKSMultipleMatchingKeys = /*#__PURE__*/function (_JOSEError12) {
  _inherits(JWKSMultipleMatchingKeys, _JOSEError12);

  var _super13 = _createSuper(JWKSMultipleMatchingKeys);

  function JWKSMultipleMatchingKeys() {
    var _this13;

    _classCallCheck(this, JWKSMultipleMatchingKeys);

    _this13 = _super13.apply(this, arguments);
    _this13.code = 'ERR_JWKS_MULTIPLE_MATCHING_KEYS';
    _this13.message = 'multiple matching keys found in the JSON Web Key Set';
    return _this13;
  }

  _createClass(JWKSMultipleMatchingKeys, null, [{
    key: "code",
    get: function get() {
      return 'ERR_JWKS_MULTIPLE_MATCHING_KEYS';
    }
  }]);

  return JWKSMultipleMatchingKeys;
}(JOSEError);
export var JWKSTimeout = /*#__PURE__*/function (_JOSEError13) {
  _inherits(JWKSTimeout, _JOSEError13);

  var _super14 = _createSuper(JWKSTimeout);

  function JWKSTimeout() {
    var _this14;

    _classCallCheck(this, JWKSTimeout);

    _this14 = _super14.apply(this, arguments);
    _this14.code = 'ERR_JWKS_TIMEOUT';
    _this14.message = 'request timed out';
    return _this14;
  }

  _createClass(JWKSTimeout, null, [{
    key: "code",
    get: function get() {
      return 'ERR_JWKS_TIMEOUT';
    }
  }]);

  return JWKSTimeout;
}(JOSEError);
export var JWSSignatureVerificationFailed = /*#__PURE__*/function (_JOSEError14) {
  _inherits(JWSSignatureVerificationFailed, _JOSEError14);

  var _super15 = _createSuper(JWSSignatureVerificationFailed);

  function JWSSignatureVerificationFailed() {
    var _this15;

    _classCallCheck(this, JWSSignatureVerificationFailed);

    _this15 = _super15.apply(this, arguments);
    _this15.code = 'ERR_JWS_SIGNATURE_VERIFICATION_FAILED';
    _this15.message = 'signature verification failed';
    return _this15;
  }

  _createClass(JWSSignatureVerificationFailed, null, [{
    key: "code",
    get: function get() {
      return 'ERR_JWS_SIGNATURE_VERIFICATION_FAILED';
    }
  }]);

  return JWSSignatureVerificationFailed;
}(JOSEError);